import messageTypes from '@/store/messages/types'

const messages = {
  namespaced: true,
  state: {
    [messageTypes.error]: '',

    [messageTypes.isLoadingPage]: { value: false },

    [messageTypes.isLoadingCompleteQuote]: { value: false }
  },
  getters: {
    getMessage: (state) => (type) => {
      return state[type]
    }
  },
  mutations: {
    setMessage (state, payload = { type: '', value: '', class: '' }) {
      state[payload.type] = payload
    }
  }
}

export default messages
